export enum BannerTestID {
    Wrapper = 'BannerTestID.Component',
    Header = 'BannerTestID.Header',
    Description = 'BannerTestID.Description',
    CtaButton = 'BannerTestID.CtaButton',
}

export enum DropdownMenuTestID {
    MenuButton = 'DropdownMenuTestID.MenuButton',
}
